'use strict'

angular.module('shiftTraderApp').controller('BuyTokenPlanDialogCtrl', function (
  $http, $scope, Registration, $uibModalInstance, params, Users, $timeout, SAErrorHandler, ServerUrls, toastr
) {
  var vm = this

  vm.org = params.org

  vm.close = $uibModalInstance.close

  $http.get(ServerUrls.current.railsApi + 'token_ledgers/get_plans')
    .then(function(response) {
      vm.tokenPlans = response.data
    })

  $http.get(ServerUrls.current.railsApi + 'organizations/' + vm.org.id + '/token_ledgers/latest')
    .then(function(response) {
      vm.currentTokens = response.data
      console.log('TYLER', vm.currentTokens)
    })

  vm.selectedPlan = null
  vm.applySelected = function (plan) {
    vm.selectedPlan = plan
  }

  vm.state = {
    processing: false
  }

  vm.done = function () {
    if (!vm.state.processing) {
      var req = {
        method: 'POST',
        url: ServerUrls.current.railsApi + 'organizations/' + vm.org.id + '/token_ledgers/buy_plan',
        data: {
          organization_id: vm.org.id,
          plan_id: vm.selectedPlan.id
        }
      }

      $http(req).then(function(res) {
        toastr.success('You now have ' + res.data.balance + ' SMS tokens to use.', 'Purchased SMS Tokens')
        vm.close(res.data.balance)
      }, function(res) {
        SAErrorHandler.processError(res)
        vm.state.processing = false
      })
    }
  }    
})
